// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_RATING_SCORE = Array(5)
  .fill()
  .map((value, index) => index + 1)
  .reverse();
